import React from 'react';
import { Button } from '@cian/ui-kit';
import { IButtonProps } from '@cian/ui-kit/button/types/componentsProps';

import * as s from './Chip.css';

export interface IChipParams extends IButtonProps {
  isActive?: boolean;
}

/**
 * Компонент для тэгов (видоизмененная кнопка)
 */
export const Chip = ({ isActive, ...otherProps }: IChipParams) => (
  <div className={`${s['wrapper']} ${isActive ? s['_active'] : ''}`}>
    <Button {...otherProps} />
  </div>
);
